/**
 * Shared event action messages used across booking and chat components for communication with
 * parent frames/windows
 */
export const EVENT_ACTION_MESSAGES = {
  // Booking lifecycle events
  CLOSED: 'close',
  BOOKED: 'booked',
  BOOKING_CONFIRMED: 'booking-confirmed',
  RESCHEDULED: 'rescheduled',
  CANCELLED: 'prospect_cancel',

  // Availability events
  AVAILABILITY_LOADED: 'availability-loaded',
  NO_FREE_SLOTS: 'no-free-slots',
  TIMESLOT_SELECTED: 'timeslot-selected',

  // Routing events
  ROUTED: 'prospect-routed',
  ROUTING: 'routing',
  DISQUALIFIED: 'prospect-disqualified',

  // Form data events
  STARTED_LISTENING_FORM_DATA_UPDATE: 'started-listening-form-data-update',
  STOPPED_LISTENING_FORM_DATA_UPDATE: 'stopped-listening-form-data-update',

  // Enrichment events
  HIDE_ENRICHMENT_FIELDS: 'hide-enrichment-fields',
  ENRICHMENT_SUCCEEDED: 'enrichment-succeeded',

  // Error and iframe events
  ERROR: 'error',
  SET_IFRAME_SIZE: 'SetIframeSize',
} as const

export type EventActionMessage = (typeof EVENT_ACTION_MESSAGES)[keyof typeof EVENT_ACTION_MESSAGES]
